import {Component, Input, OnInit} from '@angular/core';
import {ProductSearchResult} from '../../models/search';
import {BadgeClasses} from '../../models/product';
import {COLUMN_HEADER} from 'src/app/models/table';
import {environment} from 'src/environments/environment';


@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.sass']
})
export class SearchResultComponent implements OnInit {
  @Input() public searchResults: ProductSearchResult[];

  public readonly ENV = environment;
  public readonly badgeClasses = BadgeClasses;

  public isServicePack = false;
  public headerNames: string[] = [
    COLUMN_HEADER.PUBLISHING_STATUS,
    COLUMN_HEADER.PRODUCT_STATUS,
    COLUMN_HEADER.PUBL,
    COLUMN_HEADER.TYPE,
    COLUMN_HEADER.SUB_TYPE,
    COLUMN_HEADER.VERSION,
    COLUMN_HEADER.NAME,
    COLUMN_HEADER.SMART_NUMBER,
    COLUMN_HEADER.SUPPORT_STATUS,
    COLUMN_HEADER.RELEASE_DATE,
    COLUMN_HEADER.FULL_SUPP_END_DATE,
    COLUMN_HEADER.END_OF_VERSION_SUPPORT
  ];

  private readonly SERVICE_PACK_COLUMN_NUMBER = 6;

  ngOnInit(): void {
    this.isServicePack = this.searchResults.some((curSearchResult: ProductSearchResult): boolean => !!curSearchResult.servicePackName);

    if (this.isServicePack) {
      this.headerNames.splice(this.SERVICE_PACK_COLUMN_NUMBER, 0, 'SERVICE PACK');
    }

    if (this.searchResults && this.searchResults.length > 0 && this.searchResults[0].componentId) {
      this.headerNames = ['COMPONENT NAME', 'COMPONENT VERSION'].concat(this.headerNames);
    }
  }
}
